import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getDeposit = createAsyncThunk('funding/getDeposit', async () => {
	return await AccountService.deposit();
});
